export { LoggerModule } from './logger.module';
export { LoggerService } from './services/logger.service';



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/index.ts